
import { defineComponent } from 'vue';
import utilities from '@/Utilities/common';

export default defineComponent({
    props:{
        content:{
            type: [Object, String],
            default: () => {}
        },
        moreInfo:{
            type: String,
            default: '' 
        },
        close:{
            type: String,
            default: '' 
        },
    },
    data(){
        return {
            contentClass: {},
            contentStyle: '',
            showModal: false
        }
    },
    mounted(){},
    methods:{
        openModal() {
            utilities.disableBodyScroll();
            this.showModal = true;
        },
        closeModal() {
            utilities.enableBodyScroll();
            this.showModal = false;
        }
    }
});
